import { Link } from "react-router-dom";
import type { VideoItem } from "@/types";
import { typeLabels } from "@/mocks/filters";

interface VideoListItemProps {
  video: VideoItem;
}

export default function VideoListItem({ video }: VideoListItemProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-28 sm:w-32 h-40 sm:h-44 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面海报`}
          title={`${video.title} - CC视频影视详情`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex-1 flex flex-col">
        <div className="flex items-start gap-2">
          <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors truncate">
            {video.title}
          </h3>
          <span className="shrink-0 px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-xs">
            {typeLabels[video.type]}
          </span>
        </div>

        <div className="mt-1.5 flex items-center flex-wrap gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 text-accent-600 font-medium">
            <i className="ri-star-fill text-[10px]"></i>
            {video.rating.toFixed(1)}
          </span>
          <span>{video.year}</span>
          <span>{video.region}</span>
          <span className="hidden sm:inline">{video.duration}</span>
        </div>

        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {video.summary}
        </p>

        <p className="mt-2 text-xs text-foreground-500 truncate">
          主演：{video.cast.join(" / ")}
        </p>

        <div className="mt-auto pt-2 flex flex-wrap gap-1.5">
          {video.genres.map((g) => (
            <span
              key={g}
              className="px-2 py-0.5 rounded bg-background-100 text-foreground-600 text-[11px]"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}